module.exports = __webpack_public_path__ + "img/logo.e1b6f03f.png";